<div class="fg-layout-wrapper">

  <!-- Sidebar -->
  <app-sidebar></app-sidebar>

  <!-- Main column (topbar + content) -->
  <div class="fg-main-col">

    <!-- Topbar -->
    <app-navbar (toggleSidebarEvent)="onToggleSidebar()"></app-navbar>

    <!-- Main area -->
    <div class="fg-main-area">

      <!-- Spinner for lazyload modules -->
      <div *ngIf="isLoading" class="spinner-wrapper">
        <div class="spinner">Loading...</div>
      </div>

      <div class="fg-page" contentAnimate *ngIf="!isLoading">
        <router-outlet></router-outlet>
      </div>

    </div>

    <!-- Footer -->
    <app-footer></app-footer>

  </div>

</div>